export { default } from './CamCompanionAd';
